// extracted by mini-css-extract-plugin
module.exports = {"Metrics":"Progress_Metrics__3zrFv"};